mutation CreateCharityCategory(
  $charityCategoryInput: CharityCategoryChangeInput!
) {
  createCharityCategory(
    input: { charityCategoryInput: $charityCategoryInput }
  ) {
    charityCategory {
      id
    }
  }
}
